import { createAction } from '@reduxjs/toolkit';

const FETCHING_ACCOUNT_LIST = 'FETCHING_ACCOUNT_LIST';
const FETCHING_ACCOUNT_LIST_SUCCESS = 'FETCHING_ACCOUNT_LIST_SUCCESS';
const FETCHING_ACCOUNT_LIST_FAILURE = 'FETCHING_ACCOUNT_LIST_FAILURE';
const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
const GET_ACCOUNT_DETAIL = 'GET_ACCOUNT_DETAIL';
const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
const CLEAR_ACCOUNT = 'CLEAR_ACCOUNT';
const ACCOUNT_FETCHING_ROLE_LIST = 'ACCOUNT_FETCHING_ROLE_LIST';
const ACCOUNT_FETCHING_PROVINCE_LIST = 'ACCOUNT_FETCHING_PROVINCE_LIST';
const ACCOUNT_FETCHING_DISTRICT_LIST = 'ACCOUNT_FETCHING_DISTRICT_LIST';
const ACCOUNT_FETCHING_WARD_LIST = 'ACCOUNT_FETCHING_WARD_LIST';
const ACCOUNT_FETCHING_SC_PROVINCE_LIST = 'ACCOUNT_FETCHING_SC PROVINCE_LIST';
const ACCOUNT_FETCHING_SC_DISTRICT_LIST = 'ACCOUNT_FETCHING_SC DISTRICT_LIST';
const ACCOUNT_FETCHING_SC_WARD_LIST = 'ACCOUNT_FETCHING_SC_WARD_LIST';
const ACCOUNT_FETCHING_SCHOOL_LIST = 'CLASS_FETCHING_SCHOOL_LIST';
const ACCOUNT_FETCHING_BANK_SUPPORT_LIST = 'ACCOUNT_FETCHING_BANK_SUPPORT_LIST';
const ACCOUNT_ADD_STUDENT_CLASS = 'ACCOUNT_ADD_STUDENT_CLASS';
const ACCOUNT_REMOVE_STUDENT_CLASS = 'ACCOUNT_REMOVE_STUDENT_CLASS';
const CREATE_ACCOUNT_SERIES = 'CREATE_ACCOUNT_SERIES';
const FETCHING_ACCOUNT_LIST_COURSES = 'FETCHING_ACCOUNT_LIST_COURSES';
const ENROLL_ACCOUNT_LIST_COURSES = 'ENROLL_ACCOUNT_LIST_COURSES';
const UNENROLL_ACCOUNT_LIST_COURSES = 'UNENROLL_ACCOUNT_LIST_COURSES';
const EXPORT_ACCOUNT_LIST = 'EXPORT_ACCOUNT_LIST';
const DOWNLOAD_TEMPLATE_ACCOUNT_LIST = 'DOWNLOAD_TEMPLATE_ACCOUNT_LIST';
const FETCHING_HISTORY_LOGS = 'FETCHING_HISTORY_LOGS';
const FETCHING_DELETE_HISTORY_LOGS = 'FETCHING_DELETE_HISTORY_LOGS';
const RETRY_HISTORY_TASK = 'RETRY_HISTORY_TASK';
const RETRY_SESSION_FAILURES = 'RETRY_SESSION_FAILURES';
const DELETE_USER = 'DELETE_USER';
const BULK_DELETE_ACCOUNTS = 'BULK_DELETE_ACCOUNTS';
const VALIDATE_ACCOUNT_SERIES = 'VALIDATE_ACCOUNT_SERIES';
const DOWNLOAD_VALIDATED_EXCEL = 'DOWNLOAD_VALIDATED_EXCEL';

export type DeleteUserPayload = {
    id: string | number;
};

export interface accountListSuccessPayload {
    id?: number | string;
    first_name: string;
    last_name: string;
    username: string;
    email: string;
    birth_date?: string;
    role_name: string;
    role_code: string;
    role: number;
    postal_code?: string;
    phone: string;
    identity_number?: string;
    bank_id?: string;
    bank_account_number?: string;
    bank_account_name?: string;
    is_active: 0 | 1;
    date_joined: string;
    genre?: string;
    code: string;
    wards?: any;
    address?: string;
    classes?: number;
    class_name?: string;
    school?: number;
    school_name?: string;
    school_ward?: string;
    partner_name?: string | null;
    avatar_url?: string;
    wards_code?: string;
    openedx_id?: string;
    k12_username?: string | null;
    order?: number;
    wards_2?: any;
}

type accountDataDetailType = Omit<
    accountListSuccessPayload,
    'id' | 'is_active' | 'date_joined' | 'code' | 'wards' | 'wards_2'
>;

export const fetchingAccountList = createAction(FETCHING_ACCOUNT_LIST, (filters: any) => ({
    payload: filters,
}));

export const fetchingAccountListSuccess = createAction<
    accountListSuccessPayload[]
>(FETCHING_ACCOUNT_LIST_SUCCESS);

export const fetchingAccountListFailure = createAction(
    FETCHING_ACCOUNT_LIST_FAILURE,
);

export const createAccount = createAction<accountDataDetailType>(CREATE_ACCOUNT);

export const getAccountDetail = createAction(
    GET_ACCOUNT_DETAIL,
    (id: string) => ({
        payload: { id: id },
    }),
);

export const clearAccount = createAction(CLEAR_ACCOUNT);

export const updateAccount = createAction<any>(
    UPDATE_ACCOUNT,
    (data: accountDataDetailType, id: string) => ({
        payload: { data: data, id: id },
    }),
);

export const fetchProviceList = createAction(ACCOUNT_FETCHING_PROVINCE_LIST);
export const fetchDistrictList = createAction(ACCOUNT_FETCHING_DISTRICT_LIST, (provinceId: string) => ({
    payload: { provinceId: provinceId }
}));
export const fetchWardList = createAction(ACCOUNT_FETCHING_WARD_LIST, (districtId: string) => ({
    payload: { districtId: districtId }
}));
export const fetchScProviceList = createAction(ACCOUNT_FETCHING_SC_PROVINCE_LIST);
export const fetchScDistrictList = createAction(ACCOUNT_FETCHING_SC_DISTRICT_LIST, (provinceId: string) => ({
    payload: { provinceId: provinceId }
}));
export const fetchScWardList = createAction(ACCOUNT_FETCHING_SC_WARD_LIST, (districtId: string) => ({
    payload: { districtId: districtId }
}));
export const fetchSchoolList = createAction(ACCOUNT_FETCHING_SCHOOL_LIST, (wardId: string, districtId: string, provinceId: string, newWardId?: string | null, newProvinceId?: string | null, search?: string, page?: number, page_size?: number) => ({
    payload: { wardId: wardId, districtId: districtId, provinceId: provinceId, newWardId: newWardId, newProvinceId: newProvinceId, search, page, page_size }
}));
export const fetchBankSupportList = createAction(ACCOUNT_FETCHING_BANK_SUPPORT_LIST);
export const fetchRoleList = createAction(ACCOUNT_FETCHING_ROLE_LIST);
export const addStudentToClass = createAction(
    ACCOUNT_ADD_STUDENT_CLASS,
    (classId: string, userIds: number[]) => ({
        payload: { classId, userIds },
    })
);

export const removeStudentFromClass = createAction(
    ACCOUNT_REMOVE_STUDENT_CLASS,
    (classId: string, userIds: number[]) => ({
        payload: { classId, userIds },
    })
);

export const createAccountSeries = createAction<accountDataDetailType[]>(CREATE_ACCOUNT_SERIES);

export const enrollAccountListCourses = createAction(ENROLL_ACCOUNT_LIST_COURSES, (email: string, course_ids: string[]) => ({
    payload: { email: email, course_ids: course_ids }
}));

export const unenrollAccountListCourses = createAction(UNENROLL_ACCOUNT_LIST_COURSES, (email: string, course_ids: string[]) => ({
    payload: { email: email, course_ids: course_ids }
}));

export const fetchAccountListCourses = createAction(FETCHING_ACCOUNT_LIST_COURSES, (email: string) => ({
    payload: { email: email }
}));

export const exportAccountList = createAction(EXPORT_ACCOUNT_LIST, (filters: any) => ({
    payload: { ...filters, is_export: true }
}));

export const downloadTemplateAccountList = createAction(DOWNLOAD_TEMPLATE_ACCOUNT_LIST);

export const clearTemplateFile = createAction('CLEAR_TEMPLATE_FILE');

export const fetchHistoryLogs = createAction(FETCHING_HISTORY_LOGS, (filters: any) => ({
    payload: { ...filters }
}));

export const fetchDeleteHistoryLogs = createAction(FETCHING_DELETE_HISTORY_LOGS, (filters: any) => ({
    payload: { ...filters }
}));

export const retryHistoryTask = createAction(
    RETRY_HISTORY_TASK,
    (taskId: string) => ({
        payload: { taskId }
    })
);

export const retrySessionFailures = createAction(
    RETRY_SESSION_FAILURES,
    (sessionId: string) => ({
        payload: { sessionId }
    })
);

export const deleteUser = createAction<DeleteUserPayload>(DELETE_USER);

export const bulkDeleteAccounts = createAction(BULK_DELETE_ACCOUNTS, (emails: string[]) => ({
    payload: { emails },
}));

// Bulk-import PREVIEW: dry-run validation, never creates an account. Same row
// shape as createAccountSeries — only the backend endpoint differs.
export const validateAccountSeries = createAction<accountDataDetailType[]>(VALIDATE_ACCOUNT_SERIES);

export const downloadValidatedExcel = createAction(
    DOWNLOAD_VALIDATED_EXCEL,
    // feErrors: row order -> { originalFileHeaderText: message }. These are the
    // FE-only (format) checks from validateUploadedData, which never otherwise
    // reach the backend — included so the exported file notes/highlights them
    // alongside backend validation failures, not just the latter.
    (sessionId: string, feErrors?: Record<string, Record<string, string>>) => ({
        payload: { sessionId, feErrors: feErrors || {} }
    })
);